module.exports = __webpack_public_path__ + "static/media/cooReady2.ceb43457.png";